import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'font-awesome/css/font-awesome.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { MouseEventHandler } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'warning' | 'error' | 'info';
  timeout?: number;
}

const showToast = ({ message, type, timeout = 3000 }: ToastProps) => {
  let color = '';
  const toastType = type || 'info';
  switch (toastType) {
    case 'success':
      color = '#025F40';
      break;
    case 'warning':
      color = '#C59404';
      break;
    case 'error':
      color = '#9A1A1E';
      break;
    case 'info':
      color = '#46568F';
      break;
    default:
      color = 'black';
  }

  const CloseButton = ({
    closeToast,
  }: {
    closeToast: MouseEventHandler<SVGSVGElement> | undefined;
  }) => (
    <FontAwesomeIcon
      icon={faX}
      className="w-[8px] ml-auto"
      onClick={closeToast}
    />
  );

  // Calling izi toast
  toast[toastType](
    <span
      style={{
        color,
        fontWeight: 400,
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
      }}
    >
      {message}
    </span>,
    {
      position: 'top-center',
      autoClose: timeout,
      closeOnClick: true,
      pauseOnHover: true,
      closeButton: CloseButton,
      draggable: true,
      style: { backgroundColor: '#fff' },
      className: 'md:w-[400px] w-[350px] mt-5 md:mt-0',
    },
  );
};

export default showToast;
